import { appRoutes } from 'constants/appRoutes'
import { imgUrls } from 'constants/imgUrls'
import React from 'react'
import { Container, Nav, Navbar } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'

const SiteHeader = () => {

    return (
        <header>
            <Navbar
                collapseOnSelect
                expand="lg"
                data-bs-theme="dark"
                className='site-navbar'>
                <Container>
                    <Navbar.Brand as={NavLink} to='/'>
                        <img src={imgUrls.logo} className="site-logo" />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="me-auto">
                            <Nav.Link as={NavLink} to={appRoutes.home}>Home</Nav.Link>
                            <Nav.Link as={NavLink} to={appRoutes.aboutUs}>About Us</Nav.Link>
                            <Nav.Link as={NavLink} to={appRoutes.services}>Services</Nav.Link>
                            <Nav.Link as={NavLink} to={appRoutes.products}>Products</Nav.Link>
                            <Nav.Link as={NavLink} to={appRoutes.contactUs}>Contact Us</Nav.Link>
                        </Nav>
                        <Nav>
                            <Nav.Link as={NavLink} to={appRoutes.login}>Login</Nav.Link>
                            <Nav.Link as={NavLink} to={appRoutes.register}>Register</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </header>
    )
}

export default SiteHeader